import React from "react";
import InsuranceCarrier from "../components/InsuranceCarrier";

// update log
// FB 4371 DK    03/29/2021    Added to invoke the insurance component

export default function InsurancePage(data:any) {
  return <InsuranceCarrier {...data} />;
}